export const ACCEPTED_FILE_TYPES = ".pdf,.jpg,.jpeg,.png,.docx";

export const MODAL_TITLE = "Online Practitioner Form";
export const SAVE_BTN_TEXT = "Submit";
export const CANCEL_BTN_TEXT = "Cancel";

export const SUBMIT_DISCLAIMER =
  "Submit the form to be listed in the members directory after approval.";
export const UPDATES_DISCLAIMER =
  "Any updates made to this form will require admin approval before taking effect.";

export const STATUS_LABEL = "Practitioner Status:";
export const STATUS_APPROVED = "Approved";
export const STATUS_PENDING = "Pending";

export const AUTO_SAVE_SAVING = "Saving...";

export const YES_NO_OPTIONS = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

export const GENDER_OPTIONS = [
  { value: "Female", label: "Female" },
  { value: "Male", label: "Male" },
  { value: "Other", label: "Other" },
  { value: "I'm not sure", label: "I'm not sure" },
  { value: "No preference", label: "No preference" },
];

export const AGE_PREFERENCES_OPTIONS = [
  {
    value: "Under 14 (Child Hypnotherapy)",
    label: "Under 14 (Child Hypnotherapy)",
  },
  { value: "14–17 (Teen Hypnotherapy)", label: "14–17 (Teen Hypnotherapy)" },
  { value: "18+ (Adults)", label: "18+ (Adults)" },
  { value: "18–25", label: "18–25" },
  { value: "26–40", label: "26–40" },
  { value: "41–60", label: "41–60" },
  { value: "61+", label: "61+" },
  { value: "All Ages", label: "All Ages" },
];

export const LABEL_TIME_ZONE = "Time Zone";
export const PLACEHOLDER_TIME_ZONE = "Select your time zone";
export const LABEL_ZOOM_LINK = "Zoom Link";
export const PLACEHOLDER_ZOOM_LINK = "Paste your Zoom session link...";
export const LABEL_HIPAA_CERTIFICATE = "HIPAA Compliance Certificate";
export const UPLOAD_LABEL_HIPAA = "Upload HIPAA Certificate";
export const LABEL_BACKGROUND_CHECK =
  "Criminal Background Check (within 24 months)";
export const UPLOAD_LABEL_BACKGROUND_CHECK = "Upload Background Check";
export const LABEL_SCOPE_OF_PRACTICE =
  "Signed Scope of Practice & Code of Ethics (E-sign)";
export const UPLOAD_LABEL_SCOPE_OF_PRACTICE = "Upload Scope of Practice";
export const LABEL_INSURANCE_CERTIFICATES =
  "Insurance Certificates (Professional & General Liability)";
export const UPLOAD_LABEL_INSURANCE = "Upload Insurance Certificates";
export const LABEL_BAA = "Business Associate Agreement (BAA) on File";
export const UPLOAD_LABEL_BAA = "Upload Business Associate Agreement";
export const LABEL_W9 = "W9 Form";
export const UPLOAD_LABEL_W9 = "Upload W9 Form";
export const LABEL_PRACTITIONER_AGREEMENT =
  "Practitioner Agreement (Independent Contractor)";
export const UPLOAD_LABEL_CLIENT_AGREEMENT =
  "Upload Client Agreement Acknowledgment";
export const COMPLIANCE_DOCUMENT_FIELDS = [
  {
    fieldName: "hipaaCertificate",
    id: "file-input-hipaaCertificate",
    label: LABEL_HIPAA_CERTIFICATE,
    uploadLabel: UPLOAD_LABEL_HIPAA,
    multiple: false,
  },
  {
    fieldName: "backgroundCheck",
    id: "file-input-backgroundCheck",
    label: LABEL_BACKGROUND_CHECK,
    uploadLabel: UPLOAD_LABEL_BACKGROUND_CHECK,
    multiple: false,
  },
  {
    fieldName: "scopeOfPractice",
    id: "file-input-scopeOfPractice",
    label: LABEL_SCOPE_OF_PRACTICE,
    uploadLabel: UPLOAD_LABEL_SCOPE_OF_PRACTICE,
    multiple: false,
  },
  {
    fieldName: "insuranceCertificates",
    id: "file-input-insuranceCertificates",
    label: LABEL_INSURANCE_CERTIFICATES,
    uploadLabel: UPLOAD_LABEL_INSURANCE,
    multiple: true,
  },
  {
    fieldName: "businessAssociateAgreementFile",
    id: "file-input-businessAssociateAgreementFile",
    label: LABEL_BAA,
    uploadLabel: UPLOAD_LABEL_BAA,
    multiple: false,
  },
  {
    fieldName: "hipaaAcknowledgement",
    id: "file-input-hipaaAcknowledgement",
    label: LABEL_W9,
    uploadLabel: UPLOAD_LABEL_W9,
    multiple: true,
  },
  {
    fieldName: "clientAgreementAckFile",
    id: "file-input-clientAgreementAckFile",
    label: LABEL_PRACTITIONER_AGREEMENT,
    uploadLabel: UPLOAD_LABEL_CLIENT_AGREEMENT,
    multiple: false,
  },
];

// Physical Office
export const LABEL_ACCESSIBLE_LOCATION = "Accessible Location";
export const PLACEHOLDER_ACCESSIBLE_LOCATION =
  "Enter your office accessible location...";
export const LABEL_POSTED_HOURS = "Posted Hours";
export const PLACEHOLDER_POSTED_HOURS = "e.g., Mon–Fri 9am–5pm";
export const LABEL_SOUND_PRIVACY = "Sound Privacy";
export const PLACEHOLDER_SOUND_PRIVACY =
  "Does your office ensure sound privacy?";
export const LABEL_LEASE_UTILITY =
  "Lease or Utility Bill (Address Verification)";
export const UPLOAD_LABEL_LEASE_UTILITY = "Upload Lease or Utility Bill";
export const LABEL_ROOM_PRIVACY_PHOTOS = "1–3 Photos (Room Privacy Setup)";
export const UPLOAD_LABEL_ROOM_PRIVACY = "Upload Room Privacy Photos";
export const LABEL_BUSINESS_TAX_RECEIPT = "Business Tax Receipt";
export const UPLOAD_LABEL_BUSINESS_TAX = "Upload Business Tax Receipt";

export const PHYSICAL_OFFICE_ROWS = [
  {
    left: {
      type: "input",
      fieldName: "physicalOffice",
      placeholder: PLACEHOLDER_ACCESSIBLE_LOCATION,
      label: LABEL_ACCESSIBLE_LOCATION,
    },
    right: {
      type: "input",
      fieldName: "postedHours",
      placeholder: PLACEHOLDER_POSTED_HOURS,
      label: LABEL_POSTED_HOURS,
    },
  },
  {
    left: {
      type: "dropdown",
      fieldName: "soundPrivacy",
      label: LABEL_SOUND_PRIVACY,
      placeholder: PLACEHOLDER_SOUND_PRIVACY,
    },
    right: {
      type: "file",
      fieldName: "leaseOrUtilityBill",
      label: LABEL_LEASE_UTILITY,
      uploadLabel: UPLOAD_LABEL_LEASE_UTILITY,
      multiple: true,
    },
  },
  {
    left: {
      type: "file",
      fieldName: "roomPrivacyPhotos",
      label: LABEL_ROOM_PRIVACY_PHOTOS,
      uploadLabel: UPLOAD_LABEL_ROOM_PRIVACY,
      multiple: true,
    },
    right: {
      type: "file",
      fieldName: "businessTaxReceipt",
      label: LABEL_BUSINESS_TAX_RECEIPT,
      uploadLabel: UPLOAD_LABEL_BUSINESS_TAX,
      multiple: false,
    },
  },
];

export const PHYSICAL_OFFICE_SECTION_TITLE =
  "Your Physical Office (if applicable)";

// Preferences
export const LABEL_LICENSED = "Are you licensed?";
export const LABEL_ACCEPT_INSURANCE = "Do you accept insurance?";
export const PLACEHOLDER_YES_NO = "Select Yes or No";
export const LABEL_GENDER = "Your Gender";
export const PLACEHOLDER_GENDER = "Select your gender";
export const LABEL_AGE_PREFERENCES = "Age Group Preferences";
export const PLACEHOLDER_AGE_PREFERENCES = "Select all that apply";

export const PREFERENCES_DROPDOWN_FIELDS = [
  {
    name: "licensed",
    label: LABEL_LICENSED,
    placeholder: PLACEHOLDER_YES_NO,
    dataKey: "YES_NO_OPTIONS",
    convertValue: true,
  },
  {
    name: "acceptInsurance",
    label: LABEL_ACCEPT_INSURANCE,
    placeholder: PLACEHOLDER_YES_NO,
    dataKey: "YES_NO_OPTIONS",
    convertValue: true,
  },
  {
    name: "gender",
    label: LABEL_GENDER,
    placeholder: PLACEHOLDER_GENDER,
    dataKey: "GENDER_OPTIONS",
    convertValue: false,
  },
];

export const PREFERENCES_AGE_FIELD = {
  name: "agePreferences",
  label: LABEL_AGE_PREFERENCES,
  placeholder: PLACEHOLDER_AGE_PREFERENCES,
  dataKey: "AGE_PREFERENCES_OPTIONS",
};
